import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRepoContext } from '../../contexts/RepoContext';
import { MembersManager } from '../../components/MembersManager';
import { repoApi } from '../../api/client';
import './RepoPage.css';

/**
 * 仓库设置（/-/settings）：依赖 RepoLayout 注入的 RepoContext。
 */
export function RepoSettingsPage() {
    const ctx = useRepoContext();
    const navigate = useNavigate();
    const [deleting, setDeleting] = useState(false);

    if (!ctx || ctx.loading || !ctx.repo) {
        return (
            <div className="repo-page settings-tab" style={{ padding: '1.5rem' }}>
                <p className="text-muted">加载设置中…</p>
            </div>
        );
    }

    const { repo, branches } = ctx;
    const canAdmin = repo.canAdmin === true;

    const handleDeleteRepo = async () => {
        const confirmed = window.confirm(
            `确定要删除仓库 "${repo.fullPath}" 吗？\n\n此操作不可恢复，所有代码与历史将被永久删除。`
        );
        if (!confirmed) return;
        try {
            setDeleting(true);
            await repoApi.delete(repo.fullPath);
            navigate('/dashboard');
        } catch (err: unknown) {
            alert(err instanceof Error ? err.message : '删除仓库失败');
        } finally {
            setDeleting(false);
        }
    };

    return (
        <div className="repo-page settings-tab">
            <section className="settings-section">
                <h3>仓库设置</h3>
                <div className="setting-item">
                    <label>默认分支</label>
                    <select defaultValue={repo.defaultBranch} disabled>
                        {branches.map((b) => (
                            <option key={b.name} value={b.name}>
                                {b.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="setting-item">
                    <label>
                        <input type="checkbox" checked={repo.isPrivate} readOnly disabled />
                        私有仓库
                    </label>
                </div>
            </section>

            <section className="settings-section">
                <MembersManager repoPath={repo.fullPath} canManage={canAdmin} />
            </section>

            {canAdmin && (
                <section className="settings-section danger">
                    <h3>危险区域</h3>
                    <div className="danger-item">
                        <div>
                            <strong>删除此仓库</strong>
                            <p>删除后无法恢复，远程与存储中的对象将按服务端策略清理。</p>
                        </div>
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleDeleteRepo}
                            disabled={deleting}
                        >
                            {deleting ? '删除中…' : '删除仓库'}
                        </button>
                    </div>
                </section>
            )}
        </div>
    );
}
